var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./projects_list_frequent.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3040ab43\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./projects_list_frequent.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./projects_dropdown/components/projects_list_frequent.vue
// module id = ./projects_dropdown/components/projects_list_frequent.vue
// module chunks = main